import api from "@/lib/api";
import { toast } from "sonner";
import { openRazorpayCheckout } from "@/lib/razorpay";

export async function startCheckout(payload) {
  const { data: r } = await api.post("/payments/checkout", { origin_url: window.location.origin, ...payload });
  if (r.provider !== "razorpay") {
    window.location.href = r.checkout_url;
    return;
  }
  await new Promise((resolve) => {
    openRazorpayCheckout({
      orderData: r,
      onSuccess: async (resp) => {
        try {
          await api.post("/payments/razorpay/verify", {
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          window.location.href = `/payment/return?session_id=${r.session_id}`;
        } catch {
          toast.error("Payment verification failed. Contact support with your payment ID.");
          resolve();
        }
      },
      onDismiss: resolve,
      onError: () => { toast.error("Payment failed. Please try again."); resolve(); },
    });
  });
}
